export default __webpack_public_path__ + "static/media/triumph-street-twin-left-side-view2.6c161f07.webp";